import * as req from 'api/actions';
import * as c from './constant';

export const getDisabilityList = (payload, callback) =>
  req.list(
    c.GET_DISABILITIES,
    'api/v1/administrators/social_amelioration_citizens/settings/disabilities',
    payload,
    callback
  );

export const showDisability = (id, payload, callback) =>
  req.item(
    c.SHOW_DISABILITY,
    `api/v1/administrators/social_amelioration_citizens/settings/disabilities/${id}`,
    payload,
    callback
  );

export const updateDisability = (id, payload, callback) =>
  req.update(
    c.UPDATE_DISABILITY,
    `api/v1/administrators/social_amelioration_citizens/settings/disabilities/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const clearDisability = () => req.setList(c.GET_DISABILITIES, []);

export const createDisability = (payload, callback) =>
  req.create(
    c.CREATE_DISABILITY,
    `api/v1/administrators/social_amelioration_citizens/settings/disabilities`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeDisability = (id, payload, callback) =>
  req.remove(
    c.REMOVE_DISABILITY,
    `api/v1/administrators/social_amelioration_citizens/settings/disabilities/${id}`,
    payload,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Remove !');
      if (callback) callback();
    }
  );
